import React, { useState, useEffect } from "react";
import { CallAPI } from "services/API";

export default function EnvironmentServiceBanner(props) {
    const datetime = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit', // Renders in 12-hour format by default for en-US
        minute: '2-digit',
        hour12: true, // Explicitly ensures 12-hour format with AM/PM
    });

    const [environmentName, setEnvironmentName] = useState("");
    const [dataSource, setDataSource] = useState("");
    const [lastSyncDate, setLastSyncDate] = useState("");
    const [details, setDetails] = useState("");
    
    const fetchEnvironment = async () => {
        const response = await CallAPI("GET", `/GetEnvironment`);

        if (response) {
            if (props.setLastUpdated) {
                props.setLastUpdated({
                    GW: response.lastUpdatedGW == null ? "NA" : datetime.format(new Date(response.lastUpdatedGW)).replace(",", " at").toLowerCase(),
                    VK: response.lastUpdatedVK == null ? "NA" : datetime.format(new Date(response.lastUpdatedVK)).replace(",", " at").toLowerCase()
                });
            }
            setEnvironmentName(response.environmentName)
            setDataSource(response.isVK ? "Vazkor DB" : "Guidewire DB")
            setLastSyncDate(response.lastUpdatedVK == null ? "NA" : datetime.format(new Date(response.lastUpdatedVK)).replace(",", " at").toLowerCase())
            setDetails(response.isRedshiftIssue ? " some tables may be off due to known issues with Redshift." : "")
        }
    }

    useEffect(() => {
        if (props.setLastUpdated) {
            props.setLastUpdated({
                GW: null,
                VK: null
            });
        }
        setEnvironmentName("");
        setDataSource("");
        setLastSyncDate("");
        setDetails("");
        fetchEnvironment();
    }, [props.call]);

    return (
        <>
            <div style={{ display: "flex", flexDirection: "row", gap: "20px", width: "100%", justifyContent: "start", alignItems: "center", background: "transparent", color: "grey", marginTop: "10px", marginLeft: "1em", marginBottom: "27px" }}>
                <p>Environment: {environmentName.toUpperCase()}</p>
                <p>Data Source: {dataSource}</p>
                {dataSource === "Vazkor DB" && <p>Last Vazkor DB Sync: {lastSyncDate}</p>}
                {details?.length > 0 && <p>NOTE: {details}</p>}
            </div>
        </>
    );
}
